import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, MEDIA } from '../../../styles/theme'
import { SkeletonBox } from '../styles/SkeletonStyles'

const HeaderBar = styled.div`
  height: 64px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${SPACING.xl};
  background: var(--color-bg-primary);
  border-bottom: 1px solid var(--color-border);

  ${MEDIA.mobile} {
    padding: 0 ${SPACING.md};
  }
`

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export function SkeletonAppHeader() {
  return (
    <HeaderBar>
      <LeftSection>
        <SkeletonBox $width="100px" $height="24px" $radius={BORDER_RADIUS.sm} />
        <SkeletonBox $width="160px" $height="32px" $radius={BORDER_RADIUS.md} />
      </LeftSection>
      <RightSection>
        <SkeletonBox $width="32px" $height="32px" $radius={BORDER_RADIUS.md} />
        <SkeletonBox $width="32px" $height="32px" $radius={BORDER_RADIUS.md} />
        <SkeletonBox $width="32px" $height="32px" $radius={BORDER_RADIUS.full} />
      </RightSection>
    </HeaderBar>
  )
}
